<div style="display: flex;align-items: center;margin: 0.3em;">

    <span class="pre-point" [ngStyle]="prePointStyle"></span><span class="text">{{text}}</span>
</div>